<cm-sub-header-layout
  [title]="'Employee Information'"
  [titleLevel]="'h2'"
  [subtitle]="'Primary point of contact for this submission'"
  class="mod-margin-bottom-100 mod-display-flex"
/>
<div class="info-grid">
  <div class="info-item">
    <span class="info-label">Employee Name</span>
    <span class="info-value">{{ requestorData().name }}</span>
  </div>
  <div class="info-item">
    <span class="info-label">Employee Email</span>
    <span class="info-value">{{ requestorData().email }}</span>
  </div>
  <div class="info-item">
    <span class="info-label">Phone</span>
    <span class="info-value">{{ requestorData().phone }}</span>
  </div>
  @if (requestorData().division !== undefined) {
    <div class="info-item">
      <span class="info-label">Division</span>
      <span class="info-value">{{ requestorData().division || 'N/A' }}</span>
    </div>
  }
  @if (requestorData().department !== undefined) {
    <div class="info-item">
      <span class="info-label">Department</span>
      <span class="info-value">{{ requestorData().department || 'N/A' }}</span>
    </div>
  }
</div>
